import { useEffect, useState } from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { setLDClient } from './services/launchDarkly';

const AppLDProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLdClientSet, setIsLdClientSet] = useState(false);

  const launchdarklyClient = useLDClient();

  useEffect(() => {
    if (!launchdarklyClient) {
      return;
    }

    setLDClient(launchdarklyClient);
    setIsLdClientSet(true);
  }, [launchdarklyClient]);

  if (!isLdClientSet) {
    return null;
  }

  return children;
};

export default AppLDProvider;
